// api/MenuManager.js
import request from '@/utils/request';

/**
 * 获取当前用户的菜单权限
 */
export const getCurrentUserMenus = () => {
  const lang = localStorage.getItem('lang') || 'zh-CN';
  return request({
    url: '/api/menu/user-menus',
    method: 'get',
    params: { lang }
  });
};

/**
 * 获取所有菜单（管理员用）
 */
export const getAllMenus = () => {
  const lang = localStorage.getItem('lang') || 'zh-CN';
  return request({
    url: '/api/menu/list',
    method: 'get',
    params: { lang }
  });
};

 
 